export default {
  PLATFORM: process.env.REACT_APP_PLATFORM,
  ENVIRONMENT: process.env.REACT_APP_TARGET_ENVIRONMENT,
  REACT_APP_WEB_URL: process.env.REACT_APP_WEB_URL,
  CREATE_FLOW_VERSION: process.env.REACT_APP_AD_CREATE_FLOW_VERSION,
};
